import React, { useEffect, useState, useRef, useCallback } from "react";
import { Card, Table, Tooltip, Tag, Dropdown, Space, Form, Select, Input, Modal, } from "antd";
import IconButton from "components/ui/Button/IconButton";
import moment from "moment";
import { ImagePaths } from "utils/ImagePath";
import EmployeeFilter from "../EmployeeFilter";
import CommonTblHeader from "components/common/CommonTblHeader";
import ToastMsg from "components/common/ToastMsg";
import AddEditReimbursementRequest from "./AddEditReimbursementRequest";
import { EMPLOYEE_GET_REIMBURSEMENTS } from "constants";
import { getReimbursement } from "hooks/api/masterApi/reimbursementAPI";
import ApprovalLogPopUp from "../ApprovalLogPopUp";
import dayjs from "dayjs";
import { CommonCarouselPopup, CommonDeletePopup } from 'components/common/CommonComponent';
import { toIndianCurrency } from "utils/StringUtils";
import MyButton from "components/ui/Button/MyButton";
import { extractImageName, noBlankSpacesValidator } from "components/common/validation";
import { EyeOutlined } from "@ant-design/icons";
import useApiMethods from "hooks/apiConfig/method/apiMethods";
import { NEW_EMPLOYEE_GET_REIMBURSEMENTS } from "constant";
import { useLocation } from "react-router-dom";


const initialData = {
  reimbursement_type: "",
  reimbursement_approval_status: "",
  reimbursementTypeList: [],
  reimbursement_date: "",
}
function ReimbursementsRequest() {
  let query = "";
  let queryRef = useRef("");
  const pageSize = 10;
  const dateFormat = "YYYY-MM-DD";
  const authtoken = sessionStorage.getItem("token");

  const [addVisible, setAddVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [sorting, setSorting] = useState("");
  const [dataUpdated, setDataUpdated] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterDatas, setFilterDatas] = useState({ initialData });
  const [reorderedColumns, setReorderedColumns] = useState([]);
  const [isDraft, setIsDraft] = useState(false);
  const [isApprovalLog, setIsApprovalLog] = useState(false);
  const [approvalData, setApprovalData] = useState([]);
  const [deleteItem, setDeleteClicked] = useState({ record: undefined, isDeleteClicked: false, isDraft: false, });
  const [isCancelPopup, setIsCancelPopup] = useState(false)
  const [isLoading, setLoading] = useState(false);
  const tableContainerHeight = isDraft ? "77.5vh" : "72vh";
  const companyid = sessionStorage.getItem("userId");
  const [formData, setFormData] = useState({
    reimbursements_type: "",
    description: "",
    amount: "",
    uploaded_documents: [],
    company_id: companyid,
    is_active: true,
    cancel_reason: ""
  });
  const [form] = Form.useForm();
  const hideCursorRef = useRef(null);
  const [isImgOpen, setImgOpen] = useState(false);
  const [highlightedId, setHighlightedId] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const location = useLocation();
  
  useEffect(() => {
    if (!authtoken) {
      window.location.href = '/';
    }
  }, [authtoken]);

  useEffect(() => {
    if (location.state?.type_id) {
      setHighlightedId(location.state?.type_id);
        const timer = setTimeout(() => {
        setHighlightedId(null);
      }, 5000);
        return () => clearTimeout(timer);
    }
  }, [location]);

  const queryString =
  "?page_no=" + pageNo +
  "&page_size=" + pageSize +
  "&date=" + (filterDatas.reimbursement_date ? filterDatas.reimbursement_date : "") +
  "&reimbursement_type=" + (filterDatas.reimbursement_type ? filterDatas.reimbursement_type : "") +
  "&status=" + (filterDatas.reimbursement_approval_status ? filterDatas.reimbursement_approval_status : "") +
  "&search=" + searchText + (sorting ? `&${sorting}` : "");

  // const [data, pageInfo, loading, _message, refetch] = useApiData(getEmployeeReimbursement, {
  //   pageNo,
  //   pageSize,
  //   queryString,
  //   searchText,
  //   sorting
  // });

  const getReimbursementTypeList = async () => {
    try {
      const apiData = await getReimbursement(`drop_down=True`);
      if (apiData && apiData.status === "success" && apiData.data) {
        setFilterDatas((prevFilterData) => ({
          ...prevFilterData,
          reimbursementTypeList: [...apiData.data]
        }))
      } else {
        setFilterDatas((prevFilterData) => ({
          ...prevFilterData,
          reimbursementTypeList: []
        }))
      }
    } catch (error) {
      setFilterDatas((prevFilterData) => ({
        ...prevFilterData,
        reimbursementTypeList: []
      }))
    }
  }

  useEffect(() => {
    getReimbursementTypeList();
  }, []);

  // const userPermission = checkUserPermissionFunc("employee", "Reimbursements Request", "SubMenu");

  // useEffect(() => {
  //   if (_message && _message.isErrorMsg && _message.errorMsgText) {
  //     ToastMsg('error', _message.errorMsgText);
  //   }
  // }, [_message.errorMsgText]);

  const { fetch, update } = useApiMethods();
  const [data, setData] = useState([]);
  const [pageInfo, setPageInfo] = useState([])
  const [filter, setFilter] = useState({ pageNo: '', pageSize: '', query: '', search: '', sorting: '' })

  const fetchReimbursementData = async () => {
    const response = await fetch(NEW_EMPLOYEE_GET_REIMBURSEMENTS, filter, setLoading);
    if (response?.status) {
      setData(response?.data?.result);
      setPageInfo({
        pageNo: response.data.page_no,
        pageSize: response.data.page_size,
        totalCount: response.data.total_count,
        noOfPages: response.data.no_of_pages,
      });
    }
  };

  useEffect(() => {
    if (!authtoken) {
      window.location.href = '/';
    }
    fetchReimbursementData();
  }, [filter, authtoken]);

  const addClick = () => {
    setAddVisible(true);
    setEditVisible(false);
    setSelectedDetails({});
  };

  const handleEditClick = (details) => {
    if (editVisible && Object.keys(selectedDetails).length > 0) {
      ToastMsg('warning', "Please cancel the existing edit operation!");
    } else {
      setEditVisible(true);
      setSelectedDetails(details);
      setAddVisible(false);
    }
  };

  const handleSave = () => {
    setEditVisible(false);
    setAddVisible(false);
    setSelectedDetails({});
    setIsDraft(false);
    setFilter((prevFilter) => ({
      ...prevFilter,
      pageNo: 1,
      pageSize: pageSize || prevFilter.pageSize,
      query: queryString,
      search: searchText,
      sorting: sorting,
    }));
    setDataUpdated(!dataUpdated);
  };

  const handleCancel = () => {
    setEditVisible(false);
    setAddVisible(false);
    setSelectedDetails({});
    setIsCancelPopup(false)
  };


  // filter start
  const renderFilter = (data) => {
    setFilterDatas((prevdata) => ({ ...prevdata, ...data }));
    setFilter((prevFilter) => ({
      ...prevFilter,
      pageNo: 1,
      pageSize: pageSize || prevFilter?.pageSize,
      query: `date=${data.reimbursement_date ? dayjs(data.reimbursement_date).format("YYYY-MM-DD") : ""}&status=${data.reimbursement_approval_status ? data.reimbursement_approval_status : ""}&reimbursement_type=${data.reimbursement_type ? data.reimbursement_type : ""}`,
      search: searchText,
      sorting: sorting,
    }));
    setFilterVisible(false);
  }

  const ClosePopUp = () => {
    setFilterVisible(false);
  }

  const clearFilter = (data) => {
    setFilterDatas((prevState) => ({
      ...prevState,
      ...initialData,
      reimbursementTypeList: data.reimbursementTypeList.length > 0 ? data.reimbursementTypeList : [],
    }));
    setFilter(pageNo,
      pageSize,
      queryString,
      searchText,
      sorting);
  }
  //filter end
    
  const handleSearch = () => {
    setEditVisible(false)
    setAddVisible(false)
    setSelectedDetails({});
    setPageNo(1);
    setFilter((prevFilter) => ({
      ...prevFilter,
      pageNo: 1,
      pageSize: pageSize || prevFilter.pageSize,
      query: queryString,
      search: searchText,
      sorting: sorting,
    }));
    setDataUpdated(!dataUpdated);
  }

  const handleTableChange = (pagination, filters, sorter) => {
    const sortorder = `sort=${sorter.order === "descend" ? "desc" : sorter.order === "ascend" ? "asc" : ""}&`
    const sortQuery = sorter.order ? `${sortorder}column=${sorter.columnKey}` : ""
    queryRef.current = isDraft ? `is_draft=True` : "" + queryString;
    setFilter((prevFilter) => ({
      ...prevFilter,
      pageNo: pagination.current,
      pageSize: pagination.pageSize || prevFilter.pageSize,
      query: queryRef.current,
      sorting: sortQuery,
    }));
    setSorting(sortQuery)
  }

  const handleFilter = () => {
    setFilterVisible(true)
  }

  const handleDraft = () => {
    setIsDraft(true);
    setFilterVisible(false);
    setSorting("");
    setPageNo(1);
    queryRef.current = `is_draft=True`
    setFilter((prev) => ({
      ...prev,
      pageNo: 1,
      sorting: "",
      query: queryRef.current,
      search: searchText
    }));
  }

  const handleBackToHome = () => {
    setIsDraft(false);
    setSorting("");
    setPageNo(1);
    queryRef.current = "";
    setFilter(1,
      pageSize,
      queryRef.current,
      queryString,
      searchText,
      "");
  }

  const handleStateChanges = (search = "", reorderedList = []) => {
    setSearchText(search)
    setReorderedColumns(reorderedList)
  }

  const handleApprovalLog = (record) => {
    let data = record?.approval_log?.length > 0 ? record?.approval_log : [];
    setApprovalData(record);
    setIsApprovalLog(true)
  }

  const handleApprovalLogCls = () => {
    setIsApprovalLog(false)
    setApprovalData([]);
  }

  const handleChange = (name, value) => {
    switch (name) {
      case "amount":
        setFormData({
          ...formData,
          amount: value,
        });
        form.setFieldsValue({
          ...formData,
          amount: value,
        });
        break;
      default:
        setFormData({
          ...formData,
          [name]: value,
        });
        form.setFieldsValue({
          ...formData,
          [name]: value,
        });
    }
  };

  const handleCancelSubmit = useCallback(async () => {
    try {
      setLoading(true)
      const dataForm = new FormData();
      dataForm.append("reimbursements_type", formData.reimbursements_type ? formData.reimbursements_type : "")
      dataForm.append("description", formData.description ? formData.description : "")
      dataForm.append("cancel_reason", formData.cancel_reason ? formData.cancel_reason : "")
      dataForm.append("requested_amount", formData.amount ? +formData.amount : 0)
      formData.uploaded_documents?.length > 0 ?
        formData.uploaded_documents.forEach((image, index) => {
          if (image?.url) {
            dataForm.append(`uploaded_documents_${index + 1}`, image.url)
          } else {
            dataForm.append(`uploaded_documents_${index + 1}`, image.originFileObj)
          }
        }) : dataForm.append("uploaded_documents", []);
      dataForm.append("is_active", formData.is_active ? formData.is_active : "")
      dataForm.append("company_id", formData.company_id ? formData.company_id : "")
      dataForm.append("is_draft", false);
      dataForm.append("id", formData.id);
      dataForm.append("request_type", "cancel request");
      dataForm.append("approval_status", "cancel inprogress");

      let isFormData = true
      const response = await update(NEW_EMPLOYEE_GET_REIMBURSEMENTS, dataForm, isFormData)

      if (response?.status === 413) {
        setLoading(false);
        ToastMsg("error", "Request payload is too large");
      }

      if(response?.status === "success"){
        ToastMsg("success", response.message);
        handleSave();
        handleCancel();
        setLoading(false);
        setFormData({
          reimbursements_type: "",
          description: "",
          amount: 0,
          uploaded_documents: [],
          company_id: companyid,
          is_active: true,
          cancel_reason: ""
        })
      }
      } catch (error) {
      setLoading(false);
      ToastMsg("error", error.message);
    }
  }, [formData, companyid, handleSave, handleCancel]);

  const CancelPopup = (record) => {
    let data = record ? record : null;
    let PrevData = {
      id: data?.id ? data?.id : null,
      employee: data?.employee_id ? data?.employee_id : null,
      reimbursements_type: data.reimbursements_type_id ? data.reimbursements_type_id : "",
      description: data.description ? data.description : "",
      amount: data.requested_amount ? data.requested_amount : "",
      uploaded_documents: data.uploaded_documents?.length > 0 ?
        data.uploaded_documents.map(url => ({
          name: extractImageName(url),
          url: url
        })) : [],
      company: parseInt(data?.company_id),
      cancel_reason: ""
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      ...PrevData,
    }));
    form.setFieldsValue({
      ...PrevData
    });
    setIsCancelPopup(true)
  }

  const handleClear = () => {
    setFormData({
      ...formData,
      cancel_reason: "",
    });
    form.setFieldsValue({
      ...formData,
      cancel_reason: "",
    });
  }

  const handlePreviewImage = (e, index) => {
    e.preventDefault()    
    if (formData?.uploaded_documents.length > 0) {
      setCurrentSlide(index); // Set the clicked image index
      setImgOpen(true);
    }
  };

  const handlePreviewCancel = () => {
    setImgOpen(false);
  };

  const filterOption = (input, option) =>
    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  const handleCancelPopup = () => {
    return (
      <Modal
        centered
        open={isCancelPopup}
        onCancel={handleCancel}
        footer={null}
        width={"28vw"}
      >
        <div className="w-full">
          <p id="common_ApprovalTxt">{"Cancel Reimbursements"}</p>
          <Form
            layout="vertical"
            form={form}
            name="basicform"
            onFinish={handleCancelSubmit}
            onSubmit={(e) => e.preventDefault()}
            colon={false}
            requiredMark={false}
            style={{ width: "100%" }}
            initialValues={formData}
          >
            <div className="grid grid-cols-1">
              <Form.Item
                label="Select Reimbursements Type "
                name="reimbursements_type"
                rules={[{ required: true, message: "This field is required " }]}
                tooltip={{
                  title: "This field is required",
                  icon: <span style={{ color: "red" }}>*</span>,
                }}
              >
                <Select
                  showSearch
                  style={{ width: "100%" }}
                  value={formData.reimbursements_type ? formData.reimbursements_type : ""}
                  name={"reimbursements_type"}
                  disabled={true}
                  onChange={(value) => {
                    setFormData({
                      ...formData,
                      reimbursements_type: value ? Number(value) : "",
                    });
                    form.setFieldValue("reimbursements_type", value ? Number(value) : "");
                  }}
                  filterOption={filterOption}
                  ref={hideCursorRef}
                  onSelect={() => {
                    hideCursorRef.current.blur();
                  }}
                >
                  {filterDatas?.reimbursementTypeList.map((option) => (
                    (option.id === formData.reimbursements_type || option.is_active) ?
                      <Select.Option key={option.id} value={option.id}>{option.reimbursement_type_name}</Select.Option> : null
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="Enter Amount"
                name="amount"
                rules={[
                  {
                    required: true,
                    validator: (_, value) => {
                      if (!value) {
                        return Promise.reject(new Error('This field is required'));
                      }
                      if (parseFloat(value) <= 0) {
                        return Promise.reject(new Error('Enter a valid amount'));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
                tooltip={{
                  title: "This field is required",
                  icon: <span style={{ color: "red" }}>*</span>,
                }}
              >
                <Input
                  autoComplete='off'
                  style={{ width: "100%" }}
                  size='large'
                  name={"amount"}
                  value={formData.amount ? formData.amount : ""}
                  maxLength={7}
                  disabled={true}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  onKeyDown={(e) => {
                    // Allow only numbers, backspace, and delete keys
                    if (!/^[\d]$/.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight" && e.key !== "Home" && e.key !== "End") {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
              <Form.Item name="description">
                <Input.TextArea
                  bordered="true"
                  className="mt-2 textarea"
                  disabled={true}
                  rows={3}
                  autoSize={{
                    minRows: 3,
                    maxRows: 4,
                  }}
                  maxLength={150}
                  placeholder="Enter Description"
                  name="description"
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                />
              </Form.Item>
              <Form.Item name="uploaded_documents">
                {formData.uploaded_documents?.length > 0 ?
                  <div className="grid grid-cols-2 gap-x-3 gap-y-2 mt-2">
                    {formData.uploaded_documents.map((file, index) => (
                      <div key={index} className="flex justify-between items-center border-b" style={{ paddingInline: "0.3dvw" }}>
                        {file?.name?.length > 15 ?
                          <Tooltip title={file?.name}>{<span style={{ fontSize: "0.8vw" }}>{"..." + file?.name?.slice(-14)}</span>}</Tooltip>
                          : <p style={{ fontSize: "0.8vw" }}>{file?.name ? file?.name : "-"}</p>}
                        <div>
                          <IconButton
                            title="View"
                            icon={<EyeOutlined style={styles.closeIcon} />}
                            type="button"
                            onClick={(e) => {
                              e.preventDefault(); // Prevent the default form submission behavior
                              handlePreviewImage(index);
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                  : null}
              </Form.Item>
              <div className="leaveText">
                <Form.Item
                  label="Reason For Cancel"
                  name="cancel_reason"
                  rules={[{ required: true, message: "This field is required" },
                  { validator: noBlankSpacesValidator }
                  ]}
                  tooltip={{
                    title: "This field is required",
                    icon: <span style={{ color: "red" }}>*</span>,
                  }}
                >
                  <Input.TextArea
                    bordered={true}
                    className="mt-2 textarea"
                    maxLength={150}
                    rows={3}
                    autoSize={{
                      minRows: 3,
                      maxRows: 4,
                    }}
                    placeholder="Enter reason for Cancel"
                    name="cancel_reason"
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        cancel_reason: e.target.value,
                      });
                    }}
                  />
                </Form.Item>
              </div>
            </div>
            <Form.Item>
              <div className='flex justify-end items-end'>
                <MyButton htmlType="button" label={"Cancel"} onClick={() => handleClear()} bgColor={"#cbcbcb"} loading={isLoading} paddingX={"0 1.2vw"} marginRight={"0.625vw"} />
                <MyButton htmlType="submit" label={"Submit"} loading={isLoading} paddingX={"0 1.2vw"} />
              </div>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    )
  }


  const columns = [
    {
      title: "Date", 
      dataIndex: "date",
      key: "date",
      sorter: true,
      width: "12%",
      render: (_, record) => (
        <span style={{ color: "black" }}>
          {record.date ? moment(record.date, dateFormat).format('DD-MM-YYYY') : "-"}
        </span>
      ),
      align: 'center',
      fixed: "left",
    },
    {
      title: "Reimbursements Type ",
      dataIndex: "reimbursements_type",
      key: "reimbursements_type",
      sorter: true,
      width: "18%",
      fixed: "left",
      render: (_, record) =>
      (record?.reimbursements_type?.length > 30 ?
        <Tooltip title={record?.reimbursements_type?.name}>{<span style={{ color: "black" }}>{record?.reimbursements_type?.name?.slice(0, 30) + "..."}</span>}</Tooltip>
        : <p style={{ color: "black" }}>{record?.reimbursements_type ? record?.reimbursements_type?.name : "-"}</p>)
    },
    {
      title: "Requested (INR)",
      dataIndex: "requested_amount",
      key: "requested_amount",
      sorter: true,
      align: 'right',
      width: "14%",
      fixed: "left",
      render: (_, record) => (<p style={{ color: "black" }}>{record?.requested_amount ? toIndianCurrency(record?.requested_amount) : "0.00"}</p>)
    },
    {
      title: "Description ",
      dataIndex: "description",
      key: "description",
      sorter: true,
      width: "14%",
      fixed: "left",
      render: (_, record) =>
      (record?.description?.length > 30 ?
        <Tooltip title={record?.description}>{<span style={{ color: "black" }}>{record?.description?.slice(0, 30) + "..."}</span>}</Tooltip>
        : <p style={{ color: "black" }}>{record?.description ? record?.description : "-"}</p>)
    },
    {
      title: "Approved (INR)",
      dataIndex: "approved_amount",
      key: "approved_amount",
      sorter: true,
      align: 'right',
      width: "14%",
      fixed: "left",
      render: (_, record) => (<p style={{ color: "black" }}>{record?.approved_amount ? toIndianCurrency(record?.approved_amount) : toIndianCurrency(0.00)}</p>)
    },
    {
      title: "Status",
      dataIndex: "approval_status",
      key: "approval_status",
      sorter: true,
      width: "15.5%",
      align: 'center',
      fixed: "left",
      render: (_, record) => {
        let colors = (record.approval_status === "rejected" || record.approval_status === "cancelled") ? "#D94854" : (record.approval_status === "pending" || record.approval_status === "cancel inprogress") ? "#E28F12" : "#0E862A";
        return (<Tag className="statusDiv"  color={colors} key={record.approval_status}>{record.approval_status}</Tag>)
      }
    },
    {
      title: "Action",
      key: "action",
      align: 'center',
      width: "12.5%",
      fixed: "left",
      render: (_, record) => {
        const items = [
          {
            key: "1",
            label: (<div className="empApproveTxt">Approval Log</div>),
          },
          {
            key: "2",
            label: (<div className="empApproveTxt">Cancel Request</div>),
            disabled: record.approval_status !== "approved" || !record?.enable_cancel_request,
          }
        ];
        return (
          <div className="flex justify-center items-center">
            <Space size={"middle"}>
              <IconButton title="Edit" marginTop={true}
                disabled={record.approval_status !== "pending"}
                icon={<img src={record.approval_status === "pending" ? ImagePaths.edit.default : ImagePaths.editOff.default} alt="Edit" />}
                onClick={() => isLoading ? "" : handleEditClick(record)} />

              {record.approval_status === "pending" ? <IconButton
                title="Delete" marginTop={true}
                icon={<img src={ImagePaths.delete.default} alt="Delete" />}
                onClick={() => (isLoading ? "" : record.is_draft === true ? handleDeleteClicked(record, true) : handleDeleteClicked(record, false))}
                testID={'ug_btn_delete'}
              /> : null}

              <Dropdown menu={{
                items,
                onClick: ({ key }) => {
                  if (key === '1') {
                    handleApprovalLog(record)
                  }
                  else {
                    CancelPopup(record)
                  }
                }
              }} trigger={['click']} placement="bottomLeft" overlayStyle={styles.dropOverLay}>
                <IconButton title="" icon={<img src={ImagePaths.moreIcon.default} alt="Logout" />} />
              </Dropdown>
            </Space>
          </div>
        );
      },
    }
  ];

  //delete start
  const handleDeleteClicked = (record, isFromDraft) => {
    setDeleteClicked((prevdata) => ({
      ...prevdata,
      record: record,
      isDeleteClicked: true,
      isDraft: isFromDraft,
    }));
  }

  const handleCancelBtn = () => {
    setDeleteClicked((prevdata) => ({
      ...prevdata,
      record: undefined,
      isDeleteClicked: false,
      isDraft: false,
    }));
  }

  const handleDeleteBtn = async (record, isFromDraft) => {
    try {
      var response;
      if (isFromDraft) {
        const formData = {
          "id": record.id,
          "is_active": false,
          "draft_delete": true,
          "is_draft": true,
        }
        response = await update(NEW_EMPLOYEE_GET_REIMBURSEMENTS, formData);
      } else {
        const formData = {
          id: record.id,
          is_active: false
        }
        response = await update(NEW_EMPLOYEE_GET_REIMBURSEMENTS, formData);
      }

      if (response && response?.status === "success") {
        ToastMsg("success", response.message);
        if (isFromDraft) {
          handleDraft()
          setDeleteClicked((prevdata) => ({
            ...prevdata,
            isDeleteClicked: false
          }));
        } else {
          handleBackToHome()
        }
      } else {
        ToastMsg("error", response.message);
      }
    } catch (error) {
      ToastMsg("error", error.message);
    } finally {
      handleCancelBtn();
    }
  }//delete end

  const printData =
    "?page_no=" + pageNo +
    "&page_size=" + pageSize +
    "&date=" + (filterDatas.reimbursement_date ? filterDatas.reimbursement_date : "") +
    "&reimbursement_type=" + (filterDatas.reimbursement_type ? filterDatas.reimbursement_type : "") +
    "&status=" + (filterDatas.reimbursement_approval_status ? filterDatas.reimbursement_approval_status : "") +
    "&search=" + searchText + (sorting ? `&${sorting}` : "");;

  const styles = {
    fltContainer: {
      border: "1px solid #cbcbcb",
      height: tableContainerHeight,
    },
  }

  return (
    <Card className="h-full overflow-hidden">
      <div className={"h-1/6"} >
        <CommonTblHeader pageName={"Reimbursement Request"}
          pageInfo={pageInfo}
          handleSearch={handleSearch} selectedDetails={selectedDetails} addClick={addClick}
          onStateChange={handleStateChanges} handleFilter={handleFilter} columns={columns}
          handleDraft={handleDraft} isDraft={isDraft} handleBackToHome={handleBackToHome}
          url={NEW_EMPLOYEE_GET_REIMBURSEMENTS} query={printData} addBtnLabel={"New Request"}
        />
      </div>
      <div className="h-5/6 flex justify-center items-center  mt-1">
        {filterVisible ?
          <div className="w-1/4 mt-5" style={styles.fltContainer}>
            <EmployeeFilter
              pageName={"ReimbursementRequest"}
              filterDatas={filterDatas}
              closeFilter={ClosePopUp}
              filteredData={renderFilter}
              clearData={clearFilter} />
          </div>
          : null}
        <div className={filterVisible ? "mt-5 w-3/4" : "mt-5 w-full"} style={styles.fltContainer}>
        <Table 
          columns={reorderedColumns?.length > 0 ? reorderedColumns : columns}
          dataSource={data?.length > 0 ? data : null}
          loading={isLoading}
          style = {{"--table-container-height": tableContainerHeight}}
          scroll={{ y: `calc(${tableContainerHeight} - 140px)` }}
          onChange={handleTableChange}
          pagination={{
            style: { marginRight: 20, padding: 0 },
            defaultPageSize: pageSize,
            showSizeChanger: false,
            showQuickJumper: true,
            total: pageInfo?.totalCount ? pageInfo?.totalCount : 0,
            pageSizeOptions: ["10", "20", "30"],
            pageSize,
            defaultCurrent: pageNo,
          }}
          key={isDraft ? (dataUpdated ? "draftUpdated" : "draftNotUpdated") : (dataUpdated ? "updated" : "not-updated")}
          rowClassName={(record) => {
            return record.id === highlightedId ? "highlighted-row" : "";
          }}
          onRow={(record) => ({
            onDoubleClick: () => {
              if (record.approval_status === 'pending') {
                handleEditClick(record);
              }
            },
            className: 'hover-row',
          })}
        />
        </div>
      </div>
      {isCancelPopup ?  handleCancelPopup() : null }
      {(isImgOpen && formData?.uploaded_documents.length > 0) ?
        <Modal
          centered
          open={isImgOpen}
          onCancel={handlePreviewCancel}
          footer={null}
          width={"50vw"}>
          <CommonCarouselPopup documents={[...formData?.uploaded_documents]} initialSlide={currentSlide}/>
        </Modal> : null}
      {(addVisible || (editVisible && Object.keys(selectedDetails).length > 0)) ?
        <AddEditReimbursementRequest
          editDetails={selectedDetails}
          onHide={handleCancel}
          onSave={handleSave}
          fromEdit={editVisible}
          reimbursementTypeList={filterDatas?.reimbursementTypeList?.length > 0 ? filterDatas?.reimbursementTypeList : []}
        />
        : null}
      { isApprovalLog ? <ApprovalLogPopUp TblData = {approvalData} onClose = {handleApprovalLogCls}/>: null}
      {deleteItem.isDeleteClicked ? <CommonDeletePopup handleCancelBtn={handleCancelBtn} handleDeleteBtn={() => deleteItem.isDraft ? handleDeleteBtn(deleteItem.record, true) : handleDeleteBtn(deleteItem.record, false)} /> : null}
    </Card>
  );
}

export default ReimbursementsRequest;
